import { ContentGroupKeys } from '../google-analytics';

const getZlogsType = ({ pageCategory }, state) => ({
    group: ContentGroupKeys.ZlogPageType,
    value: pageCategory(state),
});

const getZlogsCategory = ({ rollUpBucket }, state) => ({
    group: ContentGroupKeys.ZlogRollupBucket,
    value: rollUpBucket(state),
});

const getZlogsContentType = ({ contentType }, state) => {
    if (!contentType) {
        return undefined;
    }
    const type = contentType(state);
    return type ? {
        group: ContentGroupKeys.ZlogContentType,
        value: type,
    } : undefined;
};

export default function getContentGroups({ analytics, state }) {
    const contentGroups = [
        getZlogsType(analytics, state),
        getZlogsCategory(analytics, state),
    ];
    const zlogsContentType = getZlogsContentType(analytics, state);
    if (zlogsContentType) {
        contentGroups.push(zlogsContentType);
    }

    return contentGroups;
}
